import React from "react";

import StaticPageStyles from "./static_pages.module.css"
import InstagramWarning from "../components/InstagramWarning";
import {useTranslation} from "react-i18next";

export default function FiledStylesPreview() {
    return <div className={StaticPageStyles.staticPageContainerCentered}>
        <InstagramWarning/>
        <h1>Якою сьогодні буде твоя LeelaOnline?</h1>
        <h3>Обери свій настрій гри</h3>
        <h4>Може ти хочеш дати гравцю обрати? Просто відправ посилання на цю сторінку.</h4>
        <br/>

        <h7>* На цій сторінці зібрані приклади загальнодоступних стилів поля гри. </h7>
        <h7>* Приватні стилі провідників та стилі з обмеженим доступом тут не відображаються</h7>
        <br/>
        <div className={StaticPageStyles.FieldStyleContainer}>
            <h3>Шлях</h3>
            <div className={StaticPageStyles.FieldStyleSubContainer}>
                <img width={"60%"} src="https://leelaonline-web-assets.s3.eu-north-1.amazonaws.com/gamefieldpathpreview.png" alt={"GameField preview"}/>
                <ul>
                    <li>Авторське поле <a href="https://www.instagram.com/ishlyahova/" target="_blank">Шляхової Ірини</a></li>
                    <li>Улюблене поле випускників школи <a href="https://leela.academy/" target="_blank">"Ліла. Шлях провідника"</a></li>
                    <li>Можна <a href="https://leela.academy/game/" target="_blank">купити</a> надруковане на тканині у високій якості</li>
                    <li>Насичені яскраві кольори в поєднанні з темни фоном спонукають до дії</li>
                </ul>
            </div>
            <br/>
        </div>
        <br/>
        <div className={StaticPageStyles.FieldStyleContainer}>
            <h3>Нефритовий Будда</h3>
            <div className={StaticPageStyles.FieldStyleSubContainer}>
                <img width={"60%"} src="https://leelaonline-web-assets.s3.eu-north-1.amazonaws.com/gamefieldbuddahrpeview.jpg" alt={"GameField preview"}/>
                <ul>
                    <li>Поле надано <a href="https://www.instagram.com/soul.summit.a.k" target="_blank">SoulSummit</a> та <a href="https://www.instagram.com/alesia.soul.sound/" target="_blank">Олеся</a></li>
                    <li>Центральний елемент поля — смарагдовий Будда, символ пробудження та духовного усвідомлення.</li>
                    <li>Його насичений зелений колір уособлює гармонію, зростання і зв’язок із серцевою чакрою, надихаючи гравців відкрити себе справжніх.</li>
                    <li>Це поле стає порталом до внутрішніх трансформацій, де кожен крок веде до глибшого розуміння життя та своєї духовної суті.</li>

                </ul>
            </div>
            <br/>
        </div>
        <br/>
        <div className={StaticPageStyles.FieldStyleContainer}>
            <h3>Подорож самопізнання</h3>
            <div className={StaticPageStyles.FieldStyleSubContainer}>
                <img width={"60%"} src="https://leelaonline-web-assets.s3.eu-north-1.amazonaws.com/gamefieldkolodchenkopreview.jpg" alt={"GameField preview"}/>
                <div style={{marginLeft:"10px"}}>
                    <span>«Ліла: Подорож самопізнання» створена, щоби допомогти тобі:</span>
                    <ul>
                        <li>усвідомити справжні причини внутрішніх чи зовнішніх конфліктів</li>
                        <li>побачити свою тінь і прийняти її</li>
                        <li>знайти відповіді на глибинні запити — про любов, гроші, покликання, тіло чи душу</li>
                        <li>трансформувати старі програми та відчути нову силу.</li>
                    </ul>
                    <span>Запрошую тебе у подорож, яка починається з одного запиту — і веде до глибокої зустрічі з собою справжнім.</span>
                    <br/>
                    <br/>
                    <span>Поле надано <a href="https://www.instagram.com/kolodchenko.nataliia/" target="_blank">Наталією Колодченко</a></span>
                </div>

            </div>
            <br/>
        </div>
        <br/>
        <div className={StaticPageStyles.FieldStyleContainer}>
            <h3>Гайя</h3>
            <div className={StaticPageStyles.FieldStyleSubContainer}>
                <img width={"60%"} src="https://leelaonline-web-assets.s3.eu-north-1.amazonaws.com/gamefieldgayapreview.jpg" alt={"GameField preview"}/>
                <ul>
                    <li>Поле Гайя виготовлено <a href="https://www.instagram.com/leela.designart/" target="_blank">Leela.designart</a> на замовлення <a href="https://www.instagram.com/sukhanova.inspire/" target="_blank">Олени Суханової</a> та доступне всім провідникам LeelaOnline</li>
                    <li>На ігровому полі зображена Богиня Гайя - уособлення природи, родючості та життєвої сили.</li>
                    <li>Кожна клітинка поля - це не просто крок у грі, це символ нашої взаємодії із Природою та Внутрішнім Світом, надихаюча подорож <i><b>Pro</b></i>життя до гармонії із Собою. </li>
                </ul>
            </div>
            <br/>
        </div>
        <br/>
        <div className={StaticPageStyles.FieldStyleContainer}>
            <h3>Подорож Душі</h3>
            <div className={StaticPageStyles.FieldStyleSubContainer}>
                <img width={"60%"} src="https://leelaonline-web-assets.s3.eu-north-1.amazonaws.com/gamefieldpidhainapreview.jpg" alt={"GameField preview"}/>
                <ul>
                    <li>Авторське поле Підгайної Лілії — улюблене серед випускників курсу «Мистецтво Ліли».</li>
                    <li>Це не просто гра — це дзеркало, яке відображає твою суть і те, що прагне проявитися через тебе.</li>
                    <li>Це поле говорить мовою душі, інсайтів і тонких відчуттів.</li>
                    <li>Кожен раз, заходячи у гру, ти ніби народжуєшся заново, проходиш крізь світло й тінь, щоб пригадати:
                        хто ти є насправді.</li>
                    <br/>
                    <li>Поле можна <a href="https://www.instagram.com/lilia_pidhayna/" target="_blank">придбати</a> надруковане на тканині в чудовій якості</li>
                </ul>
            </div>
            <br/>
        </div>
        <br/>
        <div className={StaticPageStyles.FieldStyleContainer}>
            <h3>Спокій</h3>
            <div className={StaticPageStyles.FieldStyleSubContainer}>
                <img width={"60%"} src="https://leelaonline-web-assets.s3.eu-north-1.amazonaws.com/gamefieldcalmrpeview.png" alt={"GameField preview"}/>
                <ul>
                    <li>Власне поле проекту LeelaOnline</li>
                    <li>Нейтральні кольори, легкі деталі, саме те що треба що б сфокусуватись на розмові з провідником</li>
                    <li>Автори: Тарас Карпенко та Ірина Петренко</li>
                </ul>
            </div>
            <br/>
        </div>
        <br/>
        <div className={StaticPageStyles.FieldStyleContainer}>
            <h3>Мрії</h3>
            <div className={StaticPageStyles.FieldStyleSubContainer}>
                <img width={"60%"} src="https://leelaonline-web-assets.s3.eu-north-1.amazonaws.com/gamefielddreamspreview.png" alt={"GameField preview"}/>
                <ul>
                    <li>Власне поле проекту LeelaOnline</li>
                    <li>Для тих хто не боїться мріяти</li>
                    <li>Автори: Юлія Семак та Тарас Карпенко</li>
                </ul>
            </div>
            <br/>
        </div>
        <br/>
        <div className={StaticPageStyles.FieldStyleContainer}>
            <h3>Двобій</h3>
            <div className={StaticPageStyles.FieldStyleSubContainer}>
                <img width={"60%"} src="https://leelaonline-web-assets.s3.eu-north-1.amazonaws.com/gamefieldfightpreview.jpg" alt={"GameField preview"}/>
                <ul>
                    <li>Власне поле проекту LeelaOnline</li>
                    <li>Підійде тим хто опинився у вирі боротьби добра та зла</li>
                    <li>Автори: Ірина Петренко та Тарас Карпенко</li>
                </ul>
            </div>
            <br/>
        </div>
        <br/>
        <div className={StaticPageStyles.FieldStyleContainer}>
            <h3>Космос</h3>
            <div className={StaticPageStyles.FieldStyleSubContainer}>
                <img width={"60%"} src="https://leelaonline-web-assets.s3.eu-north-1.amazonaws.com/gamefieldcosmospreview.jpg" alt={"GameField preview"}/>
                <ul>
                    <li>Власне поле проекту LeelaOnline</li>
                    <li>Менше деталей, більше засередженості</li>
                    <li>Автори: Ірина Петренко та Тарас Карпенко</li>
                </ul>
            </div>
            <br/>
        </div>
        <br/>
        <div className={StaticPageStyles.FieldStyleContainer}>
            <h3>Маска</h3>
            <div className={StaticPageStyles.FieldStyleSubContainer}>
                <img width={"60%"} src="https://leelaonline-web-assets.s3.eu-north-1.amazonaws.com/gamefieldmaskpreview.png" alt={"GameField preview"}/>
                <ul>
                    <li>Автор <a href="https://www.instagram.com/oskavronska/" target="_blank">Оля Скавронська</a></li>
                    <li>Дизайнер <a href="https://www.instagram.com/leela.designart/" target="_blank">Leela.designart</a> </li>
                    <li>Правда завжди всередині нас, але щоб її побачити, потрібно зняти маску. І зробити це можна лише через чесність — перед собою, перед життям, перед іншими</li>
                    <li>Це поле — мить внутрішнього пробудження. Воно запрошує в глибину себе, де страшно, але правдиво.</li>
                    <li>Саме тут стихає шум ролей, і починає говорити душа. Маска опадає — залишається тільки те, що істинне.</li>
                </ul>
            </div>
            <br/>
        </div>
        <br/>
        <div className={StaticPageStyles.FieldStyleContainer}>
            <h3>Ключ</h3>
            <div className={StaticPageStyles.FieldStyleSubContainer}>
                <img width={"60%"} src="https://leelaonline-web-assets.s3.eu-north-1.amazonaws.com/gamefieldkeypreview.png" alt={"GameField preview"}/>
                <ul>
                    <li>Автор <a href="https://www.instagram.com/oskavronska/" target="_blank">Оля Скавронська</a></li>
                    <li>Дизайнер <a href="https://www.instagram.com/leela.designart/" target="_blank">Leela.designart</a> </li>
                    <li>Ключ — це ти сама: твоя свідомість, твоє серце. Все, що здається перешкодами (змії, стріли, дим), — лише шари шляху до себе. Це момент великої сміливості — доторкнутись до власної суті.</li>
                    <li>Поле запрошує: запитай себе глибше. Знайди відповідь, яка змінює все. Тут починається справжній вхід усередину — крізь сміливість, крізь правду, крізь себе.</li>
                    <li>Той, хто зуміє взяти ключ, вже не буде колишнім.</li>
                </ul>
            </div>
            <br/>
        </div>
        <br/>
        <div className={StaticPageStyles.FieldStyleContainer}>
            <h3>Внутрішній простір</h3>
            <div className={StaticPageStyles.FieldStyleSubContainer}>
                <img width={"60%"} src="https://leelaonline-web-assets.s3.eu-north-1.amazonaws.com/gamefieldinneruniversepreview.png" alt={"GameField preview"}/>
                <ul>
                    <li>Автор <a href="https://www.instagram.com/oskavronska/" target="_blank">Оля Скавронська</a></li>
                    <li>Дизайнер <a href="https://www.instagram.com/leela.designart/" target="_blank">Leela.designart</a> </li>
                    <li>Глибоко космічне, внутрішньо зоряне, медитативне. Тут відчувається не просто самопізнання — а повернення до себе.</li>
                    <li>Це поле запрошує гравця згадати: хто я, яка моя місія, що я маю втілити в це життя.</li>
                    <li>Тут немає більше пошуку — є лише згадка.</li>
                    <li>Ти і є Всесвіт. І весь шлях був лише дорогою назад — до себе.</li>
                </ul>
            </div>
            <br/>
        </div>
        <br/>
        <div className={StaticPageStyles.FieldStyleContainer}>
            <h3>Маєш власне поле і хочеш використовувати його у LeelaOnline</h3>
            <ul>
                <li>Тільки для себе?</li>
                <li>Чи може ще й для друзів?</li>
                <li>А може хочеш поділитись з усім світом і що б воно з'явилось на цій сторінці?</li>
            </ul>
            <div>Напиши нам у <a href="mailto:support@leelaonline.net"> службу підтримки</a>, немає нічого неможливого</div>
            <br/>
        </div>

        <br/>

    </div>

}